// pages/Facturas.jsx

import React, { useState, useEffect } from 'react';
import { obtenerFacturas } from '../services/facturaService';
import { formatearFecha } from '../utils/dateUtils';
import '../styles/Facturas.css';
import { useFiscal } from '../hooks/useFiscal';

const Facturas = () => {
  const fiscal = useFiscal();
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    estado: '',
    ProyectoId: '',
    ClienteId: ''
  });

  useEffect(() => {
    cargarFacturas();
  }, []);

  const cargarFacturas = async () => {
    try {
      setLoading(true);
      const data = await obtenerFacturas(filtros);
      setFacturas(data);
    } catch (error) {
      console.error('Error cargando facturas:', error);
    } finally {
      setLoading(false);
    }
  };

const getEstadoBadge = (estado) => {
  const badges = {
    borrador: 'badge-borrador',
    emitida: 'badge-emitida',
    parcial: 'badge-parcial',
    pagada: 'badge-pagada',
    vencida: 'badge-vencida',
    anulada: 'badge-anulada'
  };
  return badges[estado] || 'badge-borrador';
};

  const formatearMonto = (monto) => {
    return new Intl.NumberFormat('es-DO', {
      style: 'currency',
      currency: fiscal.moneda?.codigo || 'DOP'
    }).format(monto);
  };

  if (loading) {
    return (
      <div className="facturas-container">
        <div className="loading">Cargando facturas...</div>
      </div>
    );
  }

  return (
    <div className="facturas-container">
      {/* Header */}
    <div className="facturas-header">
  <div>
    <h1>Facturas</h1>
    <p className="subtitle">Gestión de facturación y cuentas por cobrar</p>
  </div>
  <div style={{ display: 'flex', gap: '1rem' }}>
    <button 
      className="btn btn-info"
      onClick={() => window.location.href = '/facturas/reportes'}
    >
      📑 Reportes
    </button>
    <button 
      className="btn btn-secondary"
      onClick={() => window.location.href = '/facturas/dashboard'}
    >
      📊 Dashboard CxC
    </button>
    <button 
      className="btn btn-primary"
      onClick={() => window.location.href = '/facturas/nueva'}
    >
      + Nueva Factura
    </button>
  </div>
</div>


      {/* Filtros */}
      <div className="facturas-filtros">
        <select 
          value={filtros.estado}
          onChange={(e) => {
            setFiltros({...filtros, estado: e.target.value});
            cargarFacturas();
          }}
          className="form-select"
        >
          <option value="">Todos los estados</option>
          <option value="borrador">Borrador</option>
          <option value="emitida">Emitida</option>
          <option value="parcial">Pago Parcial</option>
          <option value="pagada">Pagada</option>
          <option value="vencida">Vencida</option>
          <option value="anulada">Anulada</option>
        </select>

        <button onClick={cargarFacturas} className="btn btn-secondary">
          🔄 Actualizar
        </button>
      </div>

      {/* Stats */}
      <div className="facturas-stats">
        <div className="stat-card">
          <div className="stat-label">Total Facturas</div>
          <div className="stat-value">{facturas.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Por Cobrar</div>
          <div className="stat-value">
            {formatearMonto(
              facturas
                .filter(f => ['emitida', 'parcial', 'vencida'].includes(f.estado))
                .reduce((sum, f) => sum + (f.saldoPendiente || 0), 0)
            )}
          </div>
        </div>
        <div className="stat-card success">
          <div className="stat-label">Pagadas</div>
          <div className="stat-value">
            {facturas.filter(f => f.estado === 'pagada').length}
          </div>
        </div>
        <div className="stat-card danger">
          <div className="stat-label">Vencidas</div>
          <div className="stat-value">
            {facturas.filter(f => f.estado === 'vencida').length}
          </div>
        </div>
      </div>

      {/* Tabla */}
      <div className="facturas-tabla-container">
        {facturas.length === 0 ? (
          <div className="empty-state">
            <p>No hay facturas registradas</p>
            <button 
              className="btn btn-primary"
              onClick={() => window.location.href = '/facturas/nueva'}
            >
              Crear primera factura
            </button>
          </div>
        ) : (
          <table className="facturas-tabla">
            <thead>
              <tr>
                <th>Número</th>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Proyecto</th>
                <th>Total</th>
                <th>Pagado</th>
                <th>Saldo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((factura) => (
                <tr key={factura.id}>
                  <td className="font-bold">{factura.numero_factura}</td>
                  <td>{formatearFecha(factura.fecha_emision)}</td>
                  <td>{factura.cliente?.nombre || '-'}</td>
                  <td>{factura.proyecto?.nombre || '-'}</td>
                  <td className="text-right">{formatearMonto(factura.total)}</td>
                  <td className="text-right">{formatearMonto(factura.totalPagado || 0)}</td>
                  <td className="text-right font-bold">
                    {formatearMonto(factura.saldoPendiente || 0)}
                  </td>
                  <td>
                    <span className={`badge ${getEstadoBadge(factura.estado)}`}>
                      {factura.estado.toUpperCase()}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="btn-icon"
                      onClick={() => window.location.href = `/facturas/${factura.id}`}
                      title="Ver detalle"
                    >
                      👁️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Facturas;